import { render, staticRenderFns } from "./Transactions.html?vue&type=template&id=6bbc60f6&scoped=true&"
import script from "./Transactions.js?vue&type=script&lang=js&"
export * from "./Transactions.js?vue&type=script&lang=js&"
import style0 from "./transactions.scss?vue&type=style&index=0&id=6bbc60f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc60f6",
  null
  
)

export default component.exports